import CustomQuestionnaire from "components/CustomQuestionnaire/CustomQuestionnaire";
import CustomSuspense from "components/CustomSuspense/CustomSuspense";
import { CenterQuestionnaireContent } from "components/InAppQuestionnaire/InAppQuestionnaire";
import type { FC } from "react";
import { ONBOARDING_QUESTIONNAIRE_INITIAL_LAB } from "src/constants/misc";
import Track from "../Track/Track";

interface QuestionnaireStepProps {
  onDataSent: () => void;
  onLastStepCompleted: () => void;
}

const InitialLabsQuestionnaireStep: FC<QuestionnaireStepProps> = ({
  onDataSent,
  onLastStepCompleted
}) => {
  return (
    <CenterQuestionnaireContent>
      <Track event="Initial Labs Dialog Questionnaire Shown" />
      <CustomSuspense>
        <CustomQuestionnaire
          resetScrollOnEachStep
          id={ONBOARDING_QUESTIONNAIRE_INITIAL_LAB}
          useRouting
          onDataSent={onDataSent}
          onLastStepCompleted={onLastStepCompleted}
        />
      </CustomSuspense>
    </CenterQuestionnaireContent>
  );
};

export default InitialLabsQuestionnaireStep;
